window.contextRequestReturnToParent = function contextRequestReturnToParent(
  panelId,
  parentIndex,
  rname,
  data
) {
  const callback = (panel: TSFixMe, parentType: TSFixMe) => {
    panel.current_type = parentType;
    window.contextRequestReturn(panel, rname, data);
  };

  window.returnToParentX(panelId, parentIndex, callback);
};

window.contextRequestReturn = function contextRequestReturn(panelId, rname, data) {
  let panel = window.xGetElementById(panelId);
  if (!panel) return;

  window.popContextRequest(panel);
  const contentMap = {} as ContentMap;
  if (panel.current_type === 'listing') {
    panel = window.getListingPannel(panel);
    if (!panel) return;
    if (window.isWorking(panel)) return;

    window.setWorking(panel);

    contentMap.method = 'POST';
    contentMap.form_name = 'listing.returnrequest';
    contentMap.ajax_listing = window.toJsonString(panel.listing);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    contentMap.key_values = window.toJsonString(panel.listing.saved_search);
    // @ts-expect-error ts-migrate(2551) FIXME: Property 'rname' does not exist on type 'ContentMa... Remove this comment to see the full error message
    contentMap.rname = rname;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'ContentMap... Remove this comment to see the full error message
    contentMap.data = data;
    contentMap.pannel_id = panel.id;
    window.doServerCall(contentMap, window.cb_refresh);
  } else {
    panel = window.getViewPannel(panel);
    if (!panel) return;
    if (window.isWorking(panel)) return;
    window.fillViewKeyValues(panel);

    window.setWorking(panel);

    contentMap.form_name = 'view.returnrequest';
    contentMap.ajax_view = window.toJsonString(panel.view);
    contentMap.key_values = window.toJsonString(panel.key_values);
    // @ts-expect-error ts-migrate(2551) FIXME: Property 'rname' does not exist on type 'ContentMa... Remove this comment to see the full error message
    contentMap.rname = rname;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'ContentMap... Remove this comment to see the full error message
    contentMap.data = data;
    contentMap.pannel_id = panel.id;

    window.doServerCall(
      contentMap,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      panel.view.path
        ? () => {
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            if (panel.view.go_back) {
              // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
              window.PageRouter.goTo(panel.view.go_back, 'go');
            } else {
              // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
              window.PageRouter.goTo(panel.view.path);
            }
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            delete panel.view.path;
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            panel.view.go_back = false;
            window.clearWorking(panel);
          }
        : window.cb_openview
    );
  }
};

window.clearContextRequest = function clearContextRequest(panelId) {
  window.setContextRequest(panelId, false);
};

window.setContextRequest = function setContextRequest(panelId, request) {
  const panel = window.xGetElementById(panelId);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  window.getListingPannel(panel);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  window.getViewPannel(panel);

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (panel.listing) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    panel.listing.request = request;
  }
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (panel.view) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    panel.view.request = request;
  }
};

window.getContextRequest = function getContextRequest(panelId: PanelId) {
  const panel = window.xGetElementById(panelId);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (panel.listing) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (panel.listing.request) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      return panel.listing.request;
    }
  }
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (panel.view) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (panel.view.request) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      return panel.view.request;
    }
  }
  return false;
};

window.refreshContextRequests = function refreshContextRequests(panelId, index) {
  const panel = window.xGetElementById(panelId);

  if (!panel) return;

  let request = window.getContextRequest(panelId);
  if (!request) {
    request = window.popContextRequest(panelId);
  }
  while (request) {
    window.setContextRequest(panelId, request);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'parent_index' does not exist on type 'st... Remove this comment to see the full error message
    if (request.parent_index < index) break;
    request = window.popContextRequest(panelId);
  }
};

window.pushContextRequest = function pushContextRequest(panelId, name, data) {
  const panel = window.xGetElementById(panelId);

  let i = 0;
  if (window.breadcrumbs && window.breadcrumbs.length) {
    i = window.breadcrumbs.length;
  }

  const request = {};
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'parent_index' does not exist on type '{}... Remove this comment to see the full error message
  request.parent_index = i;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type '{}'.
  request.name = name;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '{}'.
  request.data = data;

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
  if (!window.getContextRequest(panel)) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
    window.setContextRequest(panel, request);
    return;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (!Array.isArray(panel.context_requests)) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    panel.context_requests = [];
  }
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  panel.context_requests.push(request);
};

window.popContextRequest = function popContextRequest(panelId) {
  const panel = window.xGetElementById(panelId);

  if (!panel) return;

  window.clearContextRequest(panel);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'context_requests' does not exist on type... Remove this comment to see the full error message
  if (Array.isArray(panel.context_requests)) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'context_requests' does not exist on type... Remove this comment to see the full error message
    if (panel.context_requests.length > 0) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'context_requests' does not exist on type... Remove this comment to see the full error message
      const request = panel.context_requests.pop();
      window.setContextRequest(panel, request);
      // eslint-disable-next-line consistent-return
      return request;
    }
  }
  // eslint-disable-next-line consistent-return
  return false;
};
